import { ForecastHorizontalBase } from './base/forecast-horizontal-base';

export class ForecastHorizontal extends ForecastHorizontalBase { }